/* eslint-disable @typescript-eslint/naming-convention */
export enum KEY_CODE {
    UP = 38,
    DOWN = 40,
    ENTER = 13,
    TAB = 9,
    ESC = 27
}
